import {
	btn,
	column,
	Component,
	datasourcestore, datecolumn,
	EntityID,
	h3,
	menu, mstbar, searchbtn,
	table,
	tbar,
	Window
} from "@intermesh/goui";
import {Field, Form} from "./Form";
import {createFieldWindow, FieldWindowMap, FieldWindowMapType} from "./fields/FieldMap";
import {jmapds, principalcombo, principalDS, RecipientPicker, UserPicker} from "@intermesh/groupoffice-core";
import {t} from "./Translate";

export class FormParticipantDetail extends Component {
	private table;
	private formId?: EntityID;
	private form?: Form;
	constructor() {
		super();
		this.cls = "card";

		this.table = this.createTable();

		this.items.add(
			tbar({}, h3("Participants")),
			tbar({}, principalcombo({
					buttons: [
						btn({
							icon: "person_add",
							width: 48,
							title: t('Add users'),
							handler: () => {
								const picker = new RecipientPicker([UserPicker]);
								picker.show();

								picker.on("select",
									async ({recipients}) => {

									try {
										this.mask();
										await Promise.all(recipients.map(r => jmapds("FormParticipant").create({
											formId: this.form!.id,
											userId: r.id
										})));
									} catch(e) {
										Window.error(e);
									} finally {
										this.unmask();
									}

									}
								)
							}
						})
					],
					label: t("Add user"),
					entity: "User",
					flex: 1,
					listeners: {
						select: async ({target, record}) => {

							await jmapds("FormParticipant").create({
								formId: this.form!.id,
								userId: record.id
							})
							target.value = undefined;
						}
					}
				}),
				searchbtn({
					listeners: {
						input: ({text}) => {
							this.table.store.setFilter("search", {text: text});
							this.table.store.load();
						}
					}
				}),
				mstbar({table: this.table},
					"->",
					btn({
						icon: "delete",
						handler: async (btn) => {

							const ids = this.table.rowSelection!.getSelected().map(r => r.id);

							const result = await jmapds("FormParticipant")
								.confirmDestroy(ids);

							if(result != false) {
								btn.parent!.hide();
							}

						}
					})
				)

				),
			this.table,
		);
	}


	private createTable() {
		return table({
			rowSelectionConfig: {multiSelect: true},
			listeners: {
				delete: async ({target}) => {
					const ids = target.rowSelection!.getSelected().map(r => r.id);
					await jmapds("FormParticipant").confirmDestroy(ids);
				}
			},
			columns:[

				column({
					width: 48,
					resizable: false,
					id: "answers",
					htmlEncode: false,
					renderer: (v) => {
						const i = v === null ? "check_box_outline_blank" : "check_box";
						return `<i class="icon">${i}</i>`;
					}
				}),

				column({
					resizable: true,
					id: "user",
					header: t("Name"),
					renderer: (columnValue, record, td, table1, storeIndex) => {
						return columnValue ? columnValue.name : t("Unknown");
					}
				}),

				column({
					resizable: true,
					id: "email",
					property: "user",
					header: t("E-mail"),
					renderer: (columnValue, record, td, table1, storeIndex) => {
						return columnValue.email;
					}
				}),

				datecolumn({
					id: "sentAt",
					header: t("Sent at")
				}),

				datecolumn({
					id: "submittedAt",
					header: t("Submitted at")
				}),


				column({
					id: "btn",
					width: 48,
					renderer:(columnValue, record, td, table1, storeIndex) => {
						return btn({
							icon: "more_vert",
							menu: menu({},

								btn({
									icon: "open_in_browser",
									text: t("Open form"),
									handler: () => {
										window.open(record.url);
									}
								}),

								btn({
									icon: "delete",
									text: t("Delete"),
									handler: async button => {
										await jmapds("FormParticipant").confirmDestroy([record.id]);
									}
								})

								)
						});
					}
				})
			],
			store: datasourcestore({
				dataSource: jmapds("FormParticipant"),
				relations: {
					user: {
						dataSource: principalDS,
						path: "userId"
					}
				}
			})
		})
	}

	private edit(field:Field) {

	}


	public load(form: Form) {

		this.form = form;
		this.table.store.setFilter("formId", {"formId" : form.id});
		this.table.store.load();

	}

	private createFieldMenuOptions() {

		return Object.keys(FieldWindowMap).map(type => {
			return btn({
				text: t(type),
				handler: () => {
					if(this.form) {
						const win = createFieldWindow(type as keyof FieldWindowMapType,  this.form);
						win.show();
					}
				}
			})
		});


	}

	private async deleteField(storeIndex: number) {
		try {
			this.mask();
			this.form!.fields!.splice(storeIndex, 1);
			await jmapds("Form").update(this.form!.id, {
				fields: this.form!.fields!
			})
		} catch(e:any) {
			void Window.error(e.message);
		} finally {
			this.unmask();
		}
	}
}